import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-profile-settings-header',
  templateUrl: './header.component.html',
})
export class ProfileSettingsHeader {
  public i18n = this.translateService.instant(['User_PageTitle']);

  constructor(private translateService: TranslateService) {}
}
